import actionCreatorFactory from 'typescript-fsa';
import { Equipment, IDeviceEdgeAgentPropertiesDto, IDeviceEdgeModuleDto, ISiteSetupDTO } from 'shared/api/api';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import * as types from './types';

const actionCreator = actionCreatorFactory(GenActionFactoryName('iotHub'));

export const getDeviceProxyPropertiesAsync = actionCreator.async<
	IDeviceEdgeModuleDto,
	IDeviceEdgeModuleDto,
	{ code: number; message: string }
>(types.GET_DEVICE_PROXY_PROPERTIES);

export const setDeviceProxyPropertiesAsync = actionCreator.async<
	IDeviceEdgeModuleDto,
	IDeviceEdgeModuleDto,
	{ code: number; message: string }
>(types.SET_DEVICE_PROXY_PROPERTIES);

export const getDeviceEdgeAgentPropertiesAsync = actionCreator.async<
	{ deviceId: string; equipment: Equipment },
	IDeviceEdgeAgentPropertiesDto,
	{ code: number; message: string }
>(types.GET_DEVICE_EDGE_AGENT_PROPERTIES);

export const getDeviceConnectionStringAsync = actionCreator.async<
	{ deviceId: string; equipment: Equipment },
	string,
	{ code: number; message: string }
>(types.GET_DEVICE_CONNECTION_STRING);

export const resetIotHubState = actionCreator<void>(types.RESET_IOT_HUB_STATE);
